module.exports = __webpack_public_path__ + "static/media/bg-coach-home.c7244187.png";